import {
  AccountOutlineIcon,
  DataSourceIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import type {
  FunctionComponent,
  SVGProps,
} from "react"

import styles from "./AccountIndex.module.scss"
import { FollowOnlyMode } from "./FollowOnlyMode"
import {
  PageLink,
  PageSummary,
  PageTemplate,
} from "src/components"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.account."

export function AccountIndex() {
  const polyglot = usePolyglot()

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.account")}
    >
      <div className={styles.container}>
        <div className={styles.summaryContainer}>
          <PageSummary description={polyglot.t(`${polyglotPrefix}description`)} />
        </div>
        <PageLink
          routePath={"/account/data_source" as const}
          id="data-source"
          polyglotPhraseKey={"pages.account.pages.data_source"}
          Icon={DataSourceIcon as FunctionComponent<SVGProps<SVGElement>>}
        />
        <PageLink
          routePath={"/account/details" as const}
          id="account-details-btn"
          polyglotPhraseKey={"pages.account.pages.account_details"}
          Icon={AccountOutlineIcon as FunctionComponent<SVGProps<SVGElement>>}
        />
        <div className={styles.followOnlyWrapper}>
          <FollowOnlyMode />
        </div>
      </div>
    </PageTemplate>
  )
}
